////////////////////////////////////////////////////////////////////////////////
// This file was automatically generated by `yarn product-features:types` and
// should not be edited.
////////////////////////////////////////////////////////////////////////////////

export const IdTypes = {
  'Contract': 'Contract',
  'Course': 'Course',
  'IdentityProvider': 'IdentityProvider',
  'IntegrationTesting': 'IntegrationTesting',
  'IntegrationTesting2': 'IntegrationTesting2',
  'Organization': 'Organization',
  'Partner': 'Partner',
  'Program': 'Program',
  'Specialization': 'Specialization',
  'UnitTestId': 'UNIT_TEST_ID',
  'User': 'User',
} as const;

export type Namespaces = {
  'UnitTestNamespace': {
    'UnitTestFeature': boolean;
  };
  'authoring': {
    'enableRetirePrograms': boolean;
  };
  'courseExperiments': {
    'gwgContentABTestCourses': boolean;
  };
  'degrees': {
    'enableAiCoachForDegrees': boolean;
    'enableDegreePathwayModuleCompletionNotification': boolean;
    'enableDegreesLIHPModule': boolean;
    'enableEnterpriseDegreeStackabilityCoreLEX': boolean;
    'enableInCourseExperienceCompletionState': boolean;
    'enableInCourseExperienceUpsellNotification': boolean;
    'enableLihpMyLearningTabUpsells': boolean;
    'enableLihpPathwayDegreesCollection': boolean;
    'enableStackability': boolean;
    'enableStackablyUnenrolledLIHPModule': boolean;
    'enableWiseFlowAuthoring': boolean;
  };
  'diagnostics': {
    'enableSkillsDiagnostics': boolean;
  };
  'enterprise': {
    'allowCourseraOrgEmailsForLti': boolean;
    'allowDomainAllowlistedProgramsOnXDP': boolean;
    'allowOrgForCurriculumBuilder': boolean;
    'allowOrgForMoocFixedTerms': boolean;
    'allowOrgForSpecializationConfiguration': boolean;
    'allowShortFormContent': string;
    'allowShortFormContentBasedOnAudience': boolean;
    'alwaysReturnGradeInEnrollmentReports': boolean;
    'browseOnlyProgram': boolean;
    'businessApiAddSSOParamsToContentUrl': boolean;
    'businessApiExcludeSSOParamsFromContentUrl': boolean;
    'businessApiIncludeClipsInContentList': boolean;
    'businessApiIncludeSkillsetsAsContentTypeInContentList': boolean;
    'businessApiMaskClipsAsCoursesInContentList': boolean;
    'businessApiMaskSkillsetsAsCoursesInContentList': boolean;
    'contentCurationEnableC4B': boolean;
    'contentCurationEnableC4C': boolean;
    'contentCurationEnableC4G': boolean;
    'disableGranularGradeSyncPreferenceByOrgId': boolean;
    'disableLlmGeneratedSkillTags': boolean;
    'disableLlmGeneratedSkillTagsByContent': boolean;
    'disableSimplifiedNavigation': boolean;
    'disableUpsellBanner': boolean;
    'enableAcademicDisciplines': boolean;
    'enableAdminCoachV2': boolean;
    'enableAdminNavRedesign': boolean;
    'enableAiCoach': boolean;
    'enableAiCoachEarlyAccess': boolean;
    'enableAlternateImages': boolean;
    'enableAssignContent': boolean;
    'enableAutomatedEmailsRevamp': boolean;
    'enableC4CBFreemium': boolean;
    'enableCareerAcademyLaborMarketData': boolean;
    'enableCareerAcademyLimitedRestrictions': boolean;
    'enableCareerAcademyTestimonialsComponent': boolean;
    'enableCareerSupport': boolean;
    'enableCentralizedContentLibrary': boolean;
    'enableClipsInCollections': boolean;
    'enableCourseraIssuedBadge': boolean;
    'enableCsvEnhancement': boolean;
    'enableDataTechSku': boolean;
    'enableDayOneOnboardingFlow': boolean;
    'enableDomainVerificationForSSO': boolean;
    'enableEnhancedLearnerProfilesForAdmin': boolean;
    'enableEnhancedUserFilters': boolean;
    'enableEnterpriseCustomBadges': boolean;
    'enableEnterpriseSpecificCollection': boolean;
    'enableEnterpriseTermsOfUseModal': boolean;
    'enableForceSsoLogin': boolean;
    'enableForceSsoLoginV2Beta': boolean;
    'enableFreemium': boolean;
    'enableGenAiHubPages': boolean;
    'enableGenerateQBsFromOtherCourses': boolean;
    'enableGenericNotificationMessaging': boolean;
    'enableGradebookPlagiarismReport': boolean;
    'enableGwG': boolean;
    'enableGwGForOrg': boolean;
    'enableGwGFreemium': boolean;
    'enableGwGPaid': boolean;
    'enableGwGProgram': boolean;
    'enableIntroClipsForSkillPages': boolean;
    'enableInvitedOnlyProgram': boolean;
    'enableLearnerGroups': boolean;
    'enableLearnerProfileRecruiting': boolean;
    'enableLearnerProfileV1': boolean;
    'enableLearningPathModuleOnHome': boolean;
    'enableLtiToolConfiguration': boolean;
    'enableLtiToolEmailVerification': boolean;
    'enableMarketData': boolean;
    'enableMcpIntegration': boolean;
    'enableMergeDuplicateCollections': boolean;
    'enableNewProgramCreation': boolean;
    'enableOptimisedEnrollmentSetting': boolean;
    'enableOptimizedLearnerFlow': boolean;
    'enableOrgHomepage': boolean;
    'enableOrgHomepageAutoJoinProgram': boolean;
    'enablePermissionBasedAdminAuth': boolean;
    'enablePersonalizedReordering': boolean;
    'enableProgramAutoJoin': boolean;
    'enableRecaptchaForLtiLaunch': boolean;
    'enableRecoveryEmailPrompts': boolean;
    'enableRecruitingAssessmentColumn': boolean;
    'enableRecruitingDemoOrg': boolean;
    'enableRenderDomainsMenu': boolean;
    'enableRolePlayVoiceMode': boolean;
    'enableSelfServiceSso': boolean;
    'enableSkillSetsByDefault': boolean;
    'enableSkillsDashboard': boolean;
    'enableSkillsInSearchAndBrowse': boolean;
    'enableSkillsScoreColumns': boolean;
    'enableSkillsetRoleFilter': boolean;
    'enableUnifiedSso': boolean;
    'enableUnstopIntegration': boolean;
    'enableUserFilterV2Backend': boolean;
    'enableWildcardDomainVerification': boolean;
    'enableXapiIntegration': boolean;
    'enterpriseRecaptchaScoreForLti': string;
    'filledProgramCustomMessage': string;
    'inviteOnlyProgramDenyCustomMessage': string;
    'isAnonymousPeerReviewEnabled': boolean;
    'isCALimitedCIFeatureGated': boolean;
    'isCareerAcademyEnabled': boolean;
    'isCareerAcademyLimitedCatalog': boolean;
    'isCareerAcademySelfServeEnabled': boolean;
    'isDisallowPeerReviewUrlSharingEnabled': boolean;
    'isEnterpriseRecaptchaForLtiLaunchEnabled': boolean;
    'isLtiHonorlockEnabled': boolean;
    'isRolePageEstimatedCompletionTimeDisabled': boolean;
    'ltiDomainVerificationEnforced': boolean;
    'miniXdpEnrollAlternateCopy': boolean;
    'orgHomeBannerTagline': string;
    'personalizedRecommendations': boolean;
    'programCollectionSectionDescription': boolean;
    'programContentBox': boolean;
    'programDenyCustomMessage': string;
    'programEnableNewLearnerJourney': boolean;
    'programEulaBanner': boolean;
    'programFreeStuffVerbiage': boolean;
    'programHideCourseraRecommendations': boolean;
    'programJoinCtaAlternateCopy': boolean;
    'programJoinTrackingCustomMessage': string;
    'programJoinTrackingVerbiage': boolean;
    'programRecommendationsAvailableCoursesCopy': boolean;
    'programSkillSetFilters': boolean;
    'programSponsoredByMessage': boolean;
    'promoteAllGuidedProjectsPage': boolean;
    'recruitingAnonymizationEnabled': boolean;
    'recruitingEnabled': boolean;
    'restrictHiringSolutions': boolean;
    'skillsEnableForEnterpriseAdmins': boolean;
    'stackabilityOnXdpForEnterpriseLearners': boolean;
    'whitelistOrganizationProgramsForSSOLogin': boolean;
  };
  'enterpriseEmails': {
    'allowAccessToAdditionalContentEmails': boolean;
    'allowAnyEmailsForEnterprise': boolean;
    'allowAnyEmailsForEnterpriseByUser': boolean;
    'allowCreateProgramMembershipEmails': boolean;
    'allowDegreeBannersInEnterpriseLearnerEmails': boolean;
    'allowDeleteProgramMembershipEmails': boolean;
    'allowEnterpriseAdminInvitationEmails': boolean;
    'allowEnterpriseAdminRoleEmails': boolean;
    'allowEnterpriseLearnerReegnagementEmails': boolean;
    'allowEnterpriseLearnerReengagementEmailsV2': boolean;
    'allowEnterpriseLearnerWeeklyProgressEmails': boolean;
    'allowEnterpriseNewLearnerOnboardingEmails': boolean;
    'allowEnterpriseUserEmailUpdateEmails': boolean;
    'allowLearningNudgeEmails': boolean;
    'allowOrganizationInvitationEmails': boolean;
    'allowOrganizationInvitationReminderEmails': boolean;
    'allowOrganizationWelcomeEmails': boolean;
    'allowPendingProgramInvitationEmails': boolean;
    'allowProgramEnrollmentEmails': boolean;
    'allowProgramInvitationEmails': boolean;
    'allowProgramUnenrollmentEmails': boolean;
    'allowSkillSetAnnouncementEmails': boolean;
    'createProgramMembershipProcessorSwitchToJavaTimestamp': string;
    'hideNonCustomSectionEmailContent': boolean;
    'invitationProcessorSwitchToJavaTimestamp': string;
    'programUnenrollmentSwitchToJavaTimestamp': string;
    'rosterMembershipDeletionSwitchToJavaTimestamp': string;
    'templateIdDeleteProgramMembership': string;
    'templateIdFirstEnrollmentReminder': string;
    'templateIdFirstPendingProgramInvitation': string;
    'templateIdFirstUnenrollmentWarning': string;
    'templateIdProgramInvitation': string;
    'templateIdProgramInvitationArabic': string;
    'templateIdProgramInvitationUpswell': string;
    'templateIdProgramWelcome': string;
    'templateIdProgramWelcomeUpswell': string;
    'templateIdReengagement': string;
    'templateIdReengagementV2': string;
    'templateIdSecondEnrollmentReminder': string;
    'templateIdSecondPendingProgramInvitation': string;
    'templateIdSecondUnenrollmentWarning': string;
    'templateIdSkillSetAnnouncementEmail': string;
    'templateIdSoftDeleteProgramMembership': string;
  };
  'globalCourseFeatures': {
    'enableAudioNarrationForReadings': boolean;
    'enableCustomLabels': boolean;
    'enableDailyGoals': boolean;
    'enableDiscussionForums': boolean;
    'enableFlashcards': boolean;
    'enableItemVideoDownloads': boolean;
    'enableLearningAssistanceConnection': boolean;
    'enableLightweightPractice': boolean;
    'enableRetainingReviewsOnCourseLaunch': boolean;
  };
  'globalEmails': {
    'allowCourseEmails': boolean;
    'allowMarketingEmails': boolean;
    'allowNonTransactionalEmails': boolean;
    'allowPartnerEmails': boolean;
  };
  'globalPayments': {
    'enableFinancialAidLink': boolean;
    'enablePartnerSupportedAccess': boolean;
  };
  'integrationTesting': {
    'testFeature1WithoutAudiences': boolean;
    'testFeature2WithoutAudiences': boolean;
    'testFeatureParent': boolean;
    'testFeaturePrecedenceRules': boolean;
    'testFeatureUserIdAutoPopulation': boolean;
    'testFeatureWithAttributeServiceDependentAudience': boolean;
    'testFeatureWithNostosDependentAudience': boolean;
    'testFeatureWithNostosRelations': boolean;
    'testFeatureWithoutAudiences': boolean;
  };
  'workspaces': {
    'coachLabItemPrompt': string;
    'enableCourseIdsForInstructorLaunchLab': boolean;
    'enableGPU': boolean;
    'enableHighResourceLimits': boolean;
    'enableMaintenanceAnnouncement': string;
    'enableMaintenanceWindow': boolean;
    'enableUnlimitedImages': boolean;
    'enabledCourseIdsForAwsCloudLabs': boolean;
    'genAiLabCourseLlm': string;
    'guidedProjectsAuthoringPartnerGating': boolean;
    'guidedProjectsEasyAuthoringPartnerAllowList': boolean;
    'labsAuditAccess': boolean;
    'resourceLimitOverrides': string;
    'tensorflowGpuCourses': boolean;
  };
};

export const Defaults: Namespaces = {
  'UnitTestNamespace': {
    'UnitTestFeature': false,
  },
  'authoring': {
    'enableRetirePrograms': false,
  },
  'courseExperiments': {
    'gwgContentABTestCourses': false,
  },
  'degrees': {
    'enableAiCoachForDegrees': false,
    'enableDegreePathwayModuleCompletionNotification': false,
    'enableDegreesLIHPModule': true,
    'enableEnterpriseDegreeStackabilityCoreLEX': false,
    'enableInCourseExperienceCompletionState': false,
    'enableInCourseExperienceUpsellNotification': false,
    'enableLihpMyLearningTabUpsells': false,
    'enableLihpPathwayDegreesCollection': false,
    'enableStackability': false,
    'enableStackablyUnenrolledLIHPModule': false,
    'enableWiseFlowAuthoring': false,
  },
  'diagnostics': {
    'enableSkillsDiagnostics': true,
  },
  'enterprise': {
    'allowCourseraOrgEmailsForLti': false,
    'allowDomainAllowlistedProgramsOnXDP': true,
    'allowOrgForCurriculumBuilder': true,
    'allowOrgForMoocFixedTerms': true,
    'allowOrgForSpecializationConfiguration': true,
    'allowShortFormContent': "",
    'allowShortFormContentBasedOnAudience': true,
    'alwaysReturnGradeInEnrollmentReports': false,
    'browseOnlyProgram': false,
    'businessApiAddSSOParamsToContentUrl': false,
    'businessApiExcludeSSOParamsFromContentUrl': false,
    'businessApiIncludeClipsInContentList': false,
    'businessApiIncludeSkillsetsAsContentTypeInContentList': false,
    'businessApiMaskClipsAsCoursesInContentList': false,
    'businessApiMaskSkillsetsAsCoursesInContentList': false,
    'contentCurationEnableC4B': false,
    'contentCurationEnableC4C': false,
    'contentCurationEnableC4G': false,
    'disableGranularGradeSyncPreferenceByOrgId': false,
    'disableLlmGeneratedSkillTags': false,
    'disableLlmGeneratedSkillTagsByContent': false,
    'disableSimplifiedNavigation': false,
    'disableUpsellBanner': false,
    'enableAcademicDisciplines': false,
    'enableAdminCoachV2': false,
    'enableAdminNavRedesign': false,
    'enableAiCoach': false,
    'enableAiCoachEarlyAccess': false,
    'enableAlternateImages': false,
    'enableAssignContent': true,
    'enableAutomatedEmailsRevamp': false,
    'enableC4CBFreemium': false,
    'enableCareerAcademyLaborMarketData': true,
    'enableCareerAcademyLimitedRestrictions': false,
    'enableCareerAcademyTestimonialsComponent': true,
    'enableCareerSupport': false,
    'enableCentralizedContentLibrary': true,
    'enableClipsInCollections': false,
    'enableCourseraIssuedBadge': true,
    'enableCsvEnhancement': false,
    'enableDataTechSku': false,
    'enableDayOneOnboardingFlow': true,
    'enableDomainVerificationForSSO': false,
    'enableEnhancedLearnerProfilesForAdmin': true,
    'enableEnhancedUserFilters': true,
    'enableEnterpriseCustomBadges': false,
    'enableEnterpriseSpecificCollection': false,
    'enableEnterpriseTermsOfUseModal': true,
    'enableForceSsoLogin': false,
    'enableForceSsoLoginV2Beta': false,
    'enableFreemium': false,
    'enableGenAiHubPages': false,
    'enableGenerateQBsFromOtherCourses': false,
    'enableGenericNotificationMessaging': false,
    'enableGradebookPlagiarismReport': false,
    'enableGwG': false,
    'enableGwGForOrg': false,
    'enableGwGFreemium': false,
    'enableGwGPaid': false,
    'enableGwGProgram': false,
    'enableIntroClipsForSkillPages': false,
    'enableInvitedOnlyProgram': false,
    'enableLearnerGroups': false,
    'enableLearnerProfileRecruiting': false,
    'enableLearnerProfileV1': true,
    'enableLearningPathModuleOnHome': true,
    'enableLtiToolConfiguration': false,
    'enableLtiToolEmailVerification': false,
    'enableMarketData': false,
    'enableMcpIntegration': false,
    'enableMergeDuplicateCollections': false,
    'enableNewProgramCreation': false,
    'enableOptimisedEnrollmentSetting': true,
    'enableOptimizedLearnerFlow': true,
    'enableOrgHomepage': false,
    'enableOrgHomepageAutoJoinProgram': false,
    'enablePermissionBasedAdminAuth': false,
    'enablePersonalizedReordering': false,
    'enableProgramAutoJoin': false,
    'enableRecaptchaForLtiLaunch': false,
    'enableRecoveryEmailPrompts': true,
    'enableRecruitingAssessmentColumn': false,
    'enableRecruitingDemoOrg': true,
    'enableRenderDomainsMenu': true,
    'enableRolePlayVoiceMode': true,
    'enableSelfServiceSso': false,
    'enableSkillSetsByDefault': false,
    'enableSkillsDashboard': false,
    'enableSkillsInSearchAndBrowse': true,
    'enableSkillsScoreColumns': false,
    'enableSkillsetRoleFilter': true,
    'enableUnifiedSso': true,
    'enableUnstopIntegration': true,
    'enableUserFilterV2Backend': true,
    'enableWildcardDomainVerification': false,
    'enableXapiIntegration': false,
    'enterpriseRecaptchaScoreForLti': "0",
    'filledProgramCustomMessage': "",
    'inviteOnlyProgramDenyCustomMessage': "",
    'isAnonymousPeerReviewEnabled': false,
    'isCALimitedCIFeatureGated': true,
    'isCareerAcademyEnabled': false,
    'isCareerAcademyLimitedCatalog': false,
    'isCareerAcademySelfServeEnabled': false,
    'isDisallowPeerReviewUrlSharingEnabled': false,
    'isEnterpriseRecaptchaForLtiLaunchEnabled': false,
    'isLtiHonorlockEnabled': false,
    'isRolePageEstimatedCompletionTimeDisabled': false,
    'ltiDomainVerificationEnforced': true,
    'miniXdpEnrollAlternateCopy': false,
    'orgHomeBannerTagline': "",
    'personalizedRecommendations': true,
    'programCollectionSectionDescription': true,
    'programContentBox': true,
    'programDenyCustomMessage': "",
    'programEnableNewLearnerJourney': true,
    'programEulaBanner': false,
    'programFreeStuffVerbiage': true,
    'programHideCourseraRecommendations': false,
    'programJoinCtaAlternateCopy': false,
    'programJoinTrackingCustomMessage': "",
    'programJoinTrackingVerbiage': true,
    'programRecommendationsAvailableCoursesCopy': false,
    'programSkillSetFilters': false,
    'programSponsoredByMessage': true,
    'promoteAllGuidedProjectsPage': false,
    'recruitingAnonymizationEnabled': true,
    'recruitingEnabled': false,
    'restrictHiringSolutions': false,
    'skillsEnableForEnterpriseAdmins': false,
    'stackabilityOnXdpForEnterpriseLearners': true,
    'whitelistOrganizationProgramsForSSOLogin': true,
  },
  'enterpriseEmails': {
    'allowAccessToAdditionalContentEmails': true,
    'allowAnyEmailsForEnterprise': true,
    'allowAnyEmailsForEnterpriseByUser': true,
    'allowCreateProgramMembershipEmails': true,
    'allowDegreeBannersInEnterpriseLearnerEmails': false,
    'allowDeleteProgramMembershipEmails': true,
    'allowEnterpriseAdminInvitationEmails': true,
    'allowEnterpriseAdminRoleEmails': true,
    'allowEnterpriseLearnerReegnagementEmails': true,
    'allowEnterpriseLearnerReengagementEmailsV2': true,
    'allowEnterpriseLearnerWeeklyProgressEmails': true,
    'allowEnterpriseNewLearnerOnboardingEmails': true,
    'allowEnterpriseUserEmailUpdateEmails': true,
    'allowLearningNudgeEmails': true,
    'allowOrganizationInvitationEmails': true,
    'allowOrganizationInvitationReminderEmails': true,
    'allowOrganizationWelcomeEmails': true,
    'allowPendingProgramInvitationEmails': true,
    'allowProgramEnrollmentEmails': true,
    'allowProgramInvitationEmails': true,
    'allowProgramUnenrollmentEmails': true,
    'allowSkillSetAnnouncementEmails': true,
    'createProgramMembershipProcessorSwitchToJavaTimestamp': "1630694708000",
    'hideNonCustomSectionEmailContent': false,
    'invitationProcessorSwitchToJavaTimestamp': "1630431000000",
    'programUnenrollmentSwitchToJavaTimestamp': "1633629600000",
    'rosterMembershipDeletionSwitchToJavaTimestamp': "1633010400000",
    'templateIdDeleteProgramMembership': "program.membership.deletion",
    'templateIdFirstEnrollmentReminder': "program.firstEnrollmentTrigger.sl_test.v4",
    'templateIdFirstPendingProgramInvitation': "program.firstPendingInvitationTrigger.sl_test.v7",
    'templateIdFirstUnenrollmentWarning': "program.firstUnenrollmentTrigger",
    'templateIdProgramInvitation': "program.invitation.v5",
    'templateIdProgramInvitationArabic': "program.invitation.arabic",
    'templateIdProgramInvitationUpswell': "program.invitation.upswell.v2",
    'templateIdProgramWelcome': "program.welcome.v3",
    'templateIdProgramWelcomeUpswell': "program.welcome.upswell.v2",
    'templateIdReengagement': "enterprise.learner.reengagement.v1",
    'templateIdReengagementV2': "enterprise.learner.reengagement.v2",
    'templateIdSecondEnrollmentReminder': "program.secondEnrollmentTrigger",
    'templateIdSecondPendingProgramInvitation': "program.secondPendingInvitationTrigger.sl_test.v6",
    'templateIdSecondUnenrollmentWarning': "program.secondUnenrollmentTrigger",
    'templateIdSkillSetAnnouncementEmail': "program.skillsetAnnouncement.v1",
    'templateIdSoftDeleteProgramMembership': "program.membership.softdeletion",
  },
  'globalCourseFeatures': {
    'enableAudioNarrationForReadings': true,
    'enableCustomLabels': false,
    'enableDailyGoals': true,
    'enableDiscussionForums': true,
    'enableFlashcards': true,
    'enableItemVideoDownloads': true,
    'enableLearningAssistanceConnection': true,
    'enableLightweightPractice': false,
    'enableRetainingReviewsOnCourseLaunch': false,
  },
  'globalEmails': {
    'allowCourseEmails': true,
    'allowMarketingEmails': true,
    'allowNonTransactionalEmails': true,
    'allowPartnerEmails': true,
  },
  'globalPayments': {
    'enableFinancialAidLink': true,
    'enablePartnerSupportedAccess': false,
  },
  'integrationTesting': {
    'testFeature1WithoutAudiences': false,
    'testFeature2WithoutAudiences': false,
    'testFeatureParent': false,
    'testFeaturePrecedenceRules': false,
    'testFeatureUserIdAutoPopulation': false,
    'testFeatureWithAttributeServiceDependentAudience': false,
    'testFeatureWithNostosDependentAudience': false,
    'testFeatureWithNostosRelations': false,
    'testFeatureWithoutAudiences': false,
  },
  'workspaces': {
    'coachLabItemPrompt': "",
    'enableCourseIdsForInstructorLaunchLab': false,
    'enableGPU': false,
    'enableHighResourceLimits': false,
    'enableMaintenanceAnnouncement': "{}",
    'enableMaintenanceWindow': false,
    'enableUnlimitedImages': false,
    'enabledCourseIdsForAwsCloudLabs': false,
    'genAiLabCourseLlm': "",
    'guidedProjectsAuthoringPartnerGating': false,
    'guidedProjectsEasyAuthoringPartnerAllowList': false,
    'labsAuditAccess': false,
    'resourceLimitOverrides': "{}",
    'tensorflowGpuCourses': false,
  },
};

